module.exports = __webpack_public_path__ + "img/americanexpress.52ad483a.png";